import CopyrightIcon from '@mui/icons-material/Copyright'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import AppBar from './header/AppBar'

function About() {
  return (
    <Box sx={{backgroundColor: '#f5f8fa'}}>
      <Box sx={{minHeight: 'calc(100vh - 70px'}}>
        <AppBar />
      </Box>
      {/* body */}
      <Box maxWidth={'1320px'} margin={'auto'} height='100vh'>
        {/* title */}
        <Box display={'flex'} justifyContent={'center'} mt={6}>
          <Typography variant={'h2'} sx={{fontWeight: 700}}>
            About iScout
          </Typography>
        </Box>
        {/* sections */}
        <Box display={'flex'} flexDirection={'column'}>
          {/* section 1 */}
          <Typography variant={'h5'} fontWeight={700} mb={1}>
            Solving the DoD supply chain problem
          </Typography>
          <Box display={'flex'} gap={2} flexDirection={'column'}>
            <Typography variant={'body1'} fontSize={'1.25em'}>
              One of the key barriers to solving DoD's supply chain issue is the lack of effective
              tech scouting and market research tools. Tech scouting and market research are labor
              intensive processes because the current tools are incomplete and imprecise. As a
              result, scouts are often unable to identify the innovative companies, faculty and
              solutions that are ideally suited to address DoD's requirements.
            </Typography>
            <Typography variant={'body1'} fontSize={'1.25em'}>
              To address DoD's scouting and research requirements, Third Coast Federal and the
              University of Notre Dame developed thisiScout, an AI powered tech scouting and market
              research platform, under an Air Force Small Business Technical Transfer (STTR) award.
              iScout offers users a method for instantaneously evaluating a complex problem
              statement describing a multidisciplinary challenge (e.g., solicitation summary)
              against the capabilities of an entire marketplace to identify Innovators with the
              greatest potential to solve the challenge. iScout also allows users to search by
              technical concepts in our knowledge graph, by a known business or by traditional
              natural language phrases. In addition to businesses, iScout also returns a list of
              relevant federal SBIR|STTR and contract awards, web pages (and by June, patents and
              articles).
            </Typography>
            <Typography variant={'body1'} fontSize={'1.25em'}>
              iScout currently has over 1.5M businesses, all SBIR|STTR awards, all SAM.gov entity
              data, the last 10 years of USASpending.gov data, Crunchbase data, the Dynamic Small
              Business System (DSBS), and data from over 10M webpages of our businesses. By Fall
              2023 we will add patents, scholarly articles, faculty, and tens of thousands of
              additional businesses and their related web pages. We also will add opportunities
              published through SAM.gov (formerly FBO.gov) and Challenge.gov so that we can provide
              business users with notices of opportunities targeted to their capabilities and areas
              of interest (helping industry identify opportunities).
            </Typography>
            <Typography variant={'body1'} fontSize={'1.25em'}>
              iScout dramatically reduces the amount of time and effort required to run tech
              scouting and market research projects by recommending the most relevant companies and
              providing users with user-friendly filtering tools.
            </Typography>
            <Typography variant={'body1'} fontSize={'1.25em'}>
              iScout also helps users identify companies outside the DoD supply chain.
            </Typography>
          </Box>
          {/* section 2 */}
          <Typography variant={'h5'} fontWeight={700} mb={1} mt={5}>
            Company Competency
          </Typography>
          <Typography variant={'body1'} fontSize={'1.25em'}>
            Third Coast Federal, Inc. (TCF) provides the DoD with the tools and strategies required
            to identify and engage innovative teams from industry and academia possessing the
            capability to develop, deliver and deploy best-of- breed solutions for DoD and the
            warfighter at the speed of industry.
          </Typography>
        </Box>
      </Box>
      <Box
        style={{
          height: '50px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#181c32',
          color: 'white',
          marginBottom: 0,
          bottom: 0,
        }}
      >
        <CopyrightIcon sx={{mr: 1}} />
        2023
      </Box>
    </Box>
  )
}

export {About}
